import useDebounce from '@root/core/hooks/useDebounce';
import useTranslate from '@root/core/hooks/useTranslate';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { stateKorea } from '../../utils/Languages';
import FilterAction from '../components/filterAction';
import WarehouseList from '../components/WarehouseList';
import WarehouseTable from '../components/WarehouseTable';
import buskwarehouse from '../services/buskwarehouse';

const BuskWarehouse = () => {
  const [t] = useTranslate();
  const [rowData, setRowData] = useState();
  const [total, setTotal] = useState(0);
  const [selectedRow, setSelectedRow] = useState<React.Key[]>([]);
  const [loading, setLoading] = useState(false);
  const [filterDate, setFilterDate] = useState<[string, string]>();
  const fromDt: string = (filterDate && filterDate[0]) || '';
  const toDt: string = (filterDate && filterDate[1]) || '';
  const [filterState, setFilterState] = useState('');
  const [filter, setFilter] = useState('');
  const [filterInput, setFilterInput] = useState('');
  const debounce = useDebounce(filterInput, 1000);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState(false);
  const breadcrumbList = [
    {
      tittle: '물류센터 관리',
      url: ''
    },
    {
      tittle: '물류센터 조회',
      url: ''
    }
  ];
  const getWarehouseList = async (
    page: number,
    fromDt: string,
    toDt: string,
    state: string,
    filter: string,
    filterInput: string,
    sort: boolean
  ) => {
    setLoading(true);
    const buskWarehouseList = await buskwarehouse.getListWarehouse(
      page,
      fromDt,
      toDt,
      state,
      filter,
      filterInput,
      sort
    );
    const rowDataModified = buskWarehouseList.data?.map(
      (r: any, index: number) => {
        return {
          ...r,
          // no: index + (page - 1) * 10 + 1,
          no: r.id,
          key: r.id,
          updatedAt: formatDateTime(r.updatedAt),
          state: stateKorea(r.state)
        };
      }
    );
    setRowData(rowDataModified);
    setTotal(buskWarehouseList?.count);
    setLoading(false);
  };

  const handleStateValue = (value: string) => {
    setFilterState(value);
  };
  const handleFilterValue = (value: string) => {
    setFilter(value);
  };
  const handleInputValue = (value: string) => {
    setFilterInput(value);
  };
  const handleDateValue = (value: [string, string]) => {
    setFilterDate(value);
  };
  const onchangeSort = () => {
    setSort(!sort);
  };
  const handleChangePage = (page: number) => {
    setPage(page);
  };

  useEffect(() => {
    getWarehouseList(page, fromDt, toDt, filterState, filter, debounce, sort);
  }, [page]);

  useEffect(() => {
    if (page === 1) {
      getWarehouseList(page, fromDt, toDt, filterState, filter, debounce, sort);
    } else {
      setPage(1);
    }
  }, [fromDt, toDt, filterState, debounce, sort]);

  return (
    <div>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />
      <div className="busk-container">
        <FilterAction
          handleDateValue={handleDateValue}
          handleStateValue={handleStateValue}
          handleFilterValue={handleFilterValue}
          handleInputValue={handleInputValue}
        />
        <WarehouseList
          rowData={rowData}
          count={total}
          selectedRow={selectedRow}
          page={page}
          fromDt={fromDt}
          toDt={toDt}
          filterState={filterState}
          filter={filter}
          filterInput={filterInput}
          sort={sort}
        />
        <WarehouseTable
          rowData={rowData}
          sort={sort}
          setSort={onchangeSort}
          total={total}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          loading={loading}
          handleChangePage={handleChangePage}
          page={page}
        />
      </div>
    </div>
  );
};

export default BuskWarehouse;
